import { useEffect, useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import { CiBank } from "react-icons/ci";
import { MdOutlineCreditCard } from "react-icons/md";
import { PiSparkle } from "react-icons/pi";
import { TbChevronsUp } from "react-icons/tb";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const InfoPaymentsModal = ({
    show,
    handleClose,
}) => {

    const dontShow = () => {
        localStorage.setItem("e8-show-payment-message", false)
        handleClose()
    }

    return (
        <Modal show={show} centered onHide={handleClose}>
            <div className="modal_header">
                <p className="modal_header_title fade-in">
                    Get free credist <i><TbChevronsUp /></i>
                </p>
            </div>

            <div className="modal_main_cont">
                <div className="payment_info_hint fade-in">
                    <p className="payment_info_hint_inner">
                        Invite a friend and get $20.00 of free credits
                    </p>
                </div>
            </div>

            <div className="modal_footer">
                <div className="modal_footer_err_cont">
                </div>

                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_save_btn"
                        onClick={handleClose}
                    >
                        Understood
                    </button>
                    <button
                        className="modale_close_btn"
                        onClick={dontShow}
                    >
                        Don’t show this message again
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default InfoPaymentsModal;